import React from 'react'
import {
    change as changeFieldValue, Field, FieldArray, formValueSelector, reduxForm
} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {bindActionCreators} from 'redux';
import {buscarConfiguracoesBilhete, 
cadastrarConfiguracaoBilhete, alterarConfiguracaoBilhete} from '../../actions/configuracao-bilhete/configuracaoBilheteActions';
import { limparConfiguracaoBilhete } from '../../actions/configuracao-bilhete/selecionarBilhete';
import {
    renderFieldNumber,  required, minTamanhoCodigoEmpresa, requiredSelect, renderFieldSelect,
    renderFieldMonetarioFormulario,
    minValueMonetario,
    maxValueMonetario,
    renderFieldKM    
} from '../../util/inputs';
import {showSuccessMsg} from '../../util/messagesUtil';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import { hasPerfil, PERFIL_ADMIN } from '../../security/securityContext';

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    min,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                minLength={min}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

const renderConfigQuilometragemKmValor = ({ fields }) => (
    <>      
      {fields.map((menber, index) => (
        <div className="form-row" key={index}>
            <div className="col-12 col-sm-3 col-md-3">
                <Field name={`${menber}.codigoTarifa`} type="text" component={renderField} label="Código Tarfica"
                    readOnly={true}
                    css="form-control" />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
                <Field name={`${menber}.nomeTarifa`} type="text" component={renderField} label="Nome Tarifa"
                    readOnly={true}                                            
                    css="form-control" />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
                <Field name={`${menber}.km`}
                    type="text" 
                    css="form-control" 
                    label="Quilometragem:"
                    component={renderFieldKM} readOnly={true} />
            </div>
            <div className="col-12 col-sm-3 col-md-3">
                <Field name={`${menber}.valor`}
                    type="text" 
                    validate={[maxValueMonetario, minValueMonetario]} 
                    css="form-control" 
                    label="valor:"
                    component={renderFieldMonetarioFormulario} />
            </div>
            <Field name={`${menber}.id`} type="hidden" component={renderField} />
            <Field name={`${menber}.configuracaoBilheteId`} type="hidden" component={renderField} />
        </div>
      ))}
    </>
) 

export class ModalCadastrarConfiguracaoBilhete extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);

    }

    exibeCamposApenasLeitura() {
        return !hasPerfil(PERFIL_ADMIN)
    }

    fecharModal () {
        this.props.buscarConfiguracoesBilhete(this.props.codigoEmpresaSelecionada);
        $('#modalCadastrarConfiguracaoBilhete')
            .modal('hide');
        $('#modalCadastrarConfiguracaoBilhete')
            .hide();
        $('.modal-backdrop')
            .hide();
      this.limparFormulario();
      }

    habilitarCamposPorRegra(regra) {
        return this.props.campoRegra && this.props.campoRegra.value && this.props.campoRegra.value == regra;
    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem)
    }

    limpaViagens () {
        this.props.selecionarOrigem(null)
    }

    montarParametroBilhete(values) {
        return {
            id: this.props.configuracaoBilheteSelecionado.id,
            descricao: values.descricaoRegra,
            regra: values.campoRegra.value,
            codigoEmpresa: values.codigoEmpresa,
            sequencial: values.sequencial,            
            orgaoReguladorId: values.orgaoRegulador && values.orgaoRegulador.value ? values.orgaoRegulador.value : null,
            cidadeId: this.props.origem && this.props.origem.id ? this.props.origem.id : null,
            confBilheteKm:  values.members && values.members.length ? values.members.map(it => {
                return {
                    id: it.id,
                    configuracaoBilheteId: it.configuracaoBilheteId,
                    valor: it.valor.replace('R$', '')                    
                }
            }) : []
        };
    }

    submit(values) {
        if(this.props.configuracaoBilheteSelecionado.id) {
            this.props.alterarConfiguracaoBilhete(this.montarParametroBilhete(values), this.props.codigoEmpresaSelecionada)
            .then(() => {
                this.fecharModal();
                showSuccessMsg('Configuração alterada com sucesso');
            });
        }
        
        if(this.props.configuracaoBilheteSelecionado.id == null) {
            this.props.cadastrarConfiguracaoBilhete(this.montarParametroBilhete(values), this.props.codigoEmpresaSelecionada)
                .then(() => {
                    this.fecharModal();
                    showSuccessMsg('Configuração cadastrada com sucesso');
                });
        }
    }

    limparFormulario(){
        this.props.limparConfiguracaoBilhete();
        this.limpaViagens();
        this.props.reset('formCadastrarConfiguracaoBilhete'); 

    }

    exibeConfigKm() {        
        const confsBilheteKm = this.props.configuracaoBilheteSelecionado.confsBilheteKm
        if (confsBilheteKm.length) {            
            return <FieldArray name="members" component={renderConfigQuilometragemKmValor} />
        }
    }

    habilitaBotaoSalvarRegraW2i() {
        if (!hasPerfil(PERFIL_ADMIN) && this.props.configuracaoBilheteSelecionado.confsBilheteKm.length == 0) {
            return false;
        }

        return true
    }

    render() {
        const {
            handleSubmit, invalid, submitting
        } = this.props;
        return (
        <div className="modal fade show" id='modalCadastrarConfiguracaoBilhete' role='dialog'
        aria-labelledby='modalCadastrarConfiguracaoBilhete' aria-hidden='true' data-backdrop='static'>
            <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>{this.props.configuracaoBilheteSelecionado && this.props.configuracaoBilheteSelecionado.id ? 'Editar' : 'Cadastrar'} Configuração Bilhete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" 
                            onClick={() => this.limparFormulario()}>
                                <i className="material-icons">
                                    &#xe5cd;</i>
                            </button>
                            
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(this.submit)}>                            
                            <div className="form-row">
                                <div className="col-12 col-sm-12 col-md-5">
                                        <Field name='campoRegra'
                                        options={this.props.regraCalculoBilhete.map(elemento => ({
                                            descricao: elemento.valor,
                                            nome: elemento.chave
                                        }))}
                                        component={renderFieldSelect}
                                        validate={[requiredSelect]}
                                        label='Regra Bilhete'
                                        placeholder='Selecione...'
                                        disabled={this.exibeCamposApenasLeitura()}
                                    />
                                </div>                                
                            </div>
                            <div className="form-row">                            
                                <div className="col-12 col-sm-9 col-md-9">
                                    <Field name="descricaoRegra" type="text" component={renderField} label="Descrição da Regra"
                                        css="form-control" validate={[required]} 
                                        readOnly={this.exibeCamposApenasLeitura()} />
                                </div>
                            </div>
                            {this.habilitarCamposPorRegra('REGRA_CURITIBA') && <>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-3">
                                        <Field name="codigoEmpresa" type="text" component={renderField} label="Código da Empresa"
                                            css="form-control" validate={[required, minTamanhoCodigoEmpresa]} max={3}
                                            readOnly={this.exibeCamposApenasLeitura()} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3">
                                        <Field name="sequencial" type="text" component={renderFieldNumber} max={8} label="Sequencial"
                                            css="form-control"  validate={[required]}
                                            readOnly={this.exibeCamposApenasLeitura()} />
                                     </div>
                                </div>
                            </>}

                            {this.habilitarCamposPorRegra('REGRA_W2I') && <>
                                <div className="form-row">                                    
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <Field name='orgaoRegulador'
                                            options={this.props.orgaosReguladores.map(elemento => ({
                                                descricao: elemento.valor,
                                                nome: elemento.chave
                                            }))}
                                            component={renderFieldSelect}
                                            validate={[requiredSelect]}
                                            label='Órgão Regulador'
                                            placeholder='Selecione...'
                                            disabled={this.exibeCamposApenasLeitura()}
                                        />
                                    </div>
                                </div>
                                <div className='form-row'>                                    
                                    <div className="col-12 col-sm-5 col-md-5 mb-6 mt-3">
                                        <label htmlFor="informeCidade">Cidade:</label>                                    
                                        <SelecaoCidadeAutocomplete name='informeCidade'
                                            selecionarCidade={this.props.selecionarOrigem}
                                            value={this.props.origem}
                                            limparViagens={this.limpaViagens.bind(this)}
                                            ehVenda={true}
                                            disabled={this.exibeCamposApenasLeitura()}                                            
                                        />
                                    </div>
                                    <div className="form-group area-codigo">                                        
                                        <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12"/>
                                    </div>                                    
                                </div>                                
                                {this.exibeConfigKm()}
                            </>}
                            
                            <div className="modal-footer mt-2">
                                {this.habilitarCamposPorRegra('REGRA_CURITIBA') && hasPerfil(PERFIL_ADMIN) && <button type="submit" disabled={invalid || submitting}
                                        className="btn btn-laranja">{this.props.configuracaoBilheteSelecionado && this.props.configuracaoBilheteSelecionado.id ? 'Alterar' : 'Salvar'}
                                </button>}
                                {this.habilitarCamposPorRegra('REGRA_W2I') && this.habilitaBotaoSalvarRegraW2i() && <button type="submit" disabled={invalid || submitting || !this.props.origem}
                                        className="btn btn-laranja">{this.props.configuracaoBilheteSelecionado && this.props.configuracaoBilheteSelecionado.id ? 'Alterar' : 'Salvar'}
                                </button>}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export function mapStateToProps(state) {    
    return {
        empresaSelecionada: state.empresaSelecionada,
        configuracaoBilhete: state.configuracaoBilhete,        
        configuracaoBilheteSelecionado: state.configuracaoBilheteSelecionado,
        initialValues: {
            codigoEmpresa: state.configuracaoBilheteSelecionado && state.configuracaoBilheteSelecionado.id ? state.configuracaoBilheteSelecionado.codigoEmpresa : '',
            sequencial: state.configuracaoBilheteSelecionado && state.configuracaoBilheteSelecionado.id ? state.configuracaoBilheteSelecionado.sequencial : '0', 
            descricaoRegra: state.configuracaoBilheteSelecionado && state.configuracaoBilheteSelecionado.id ? state.configuracaoBilheteSelecionado.descricao : '',
            campoRegra: state.configuracaoBilheteSelecionado.regra ? {
                label: state.configuracaoBilheteSelecionado.regra ? state.configuracaoBilheteSelecionado.regra.valor : '',
                value: state.configuracaoBilheteSelecionado.regra ? state.configuracaoBilheteSelecionado.regra.chave : ''
            } : null,            
            orgaoRegulador: state.configuracaoBilheteSelecionado.orgaoRegulador ? {
                label: state.configuracaoBilheteSelecionado.orgaoRegulador.valor,
                value: state.configuracaoBilheteSelecionado.orgaoRegulador.chave
            } : null,
            members: state.configuracaoBilheteSelecionado.confsBilheteKm            
        },
        campoRegra: formValueSelector('formCadastrarConfiguracaoBilhete')(state, 'campoRegra'),
        origem: state.origem,
        regraCalculoBilhete: state.opcoesFiltrosConfiguracaoBilhete.regras,
        orgaosReguladores: state.opcoesFiltrosConfiguracaoBilhete.orgaosReguladores
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        buscarConfiguracoesBilhete,
        cadastrarConfiguracaoBilhete,
        limparConfiguracaoBilhete,
        alterarConfiguracaoBilhete,
        selecionarOrigem
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formCadastrarConfiguracaoBilhete',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalCadastrarConfiguracaoBilhete));
